import React from 'react';
import style from './IndexLayer.less';
import IndexHeader from 'components/IndexHeader';
import Footer from './Footer';
import {oldCheckLogin} from 'actions/oldAccount';
import { withRouter } from 'react-router-dom';
import {Spin} from 'antd';

class IndexLayer extends React.Component {

    state = {
        notLogin:false,
        // notLogin:true
    }

    componentDidMount(){
        oldCheckLogin().then(()=>{
            this.props.history.push('/pages');
        }).catch(()=>{
            this.setState({notLogin:true});
        });
    }

    render() {
        if(!this.state.notLogin){
            return <Spin><div style={{height:'500px'}}></div></Spin>;
        }
        return(
            <div style={{height:'100%'}}>
                <IndexHeader />
                <div className={style.body}>
                    <div className={style.main}>
                        <div className={style.layer}>
                            <img className={style.pic} alt="img" src={require('../image/pic.png')} />
                            <div className={style.formLayer}>
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withRouter(IndexLayer);



// WEBPACK FOOTER //
// ./src/components/IndexLayer.js